/* Section « Onglets produit »
   - Read-more « En savoir plus » sur la description (clamp 4 lignes).
   - Volets plein ecran (slide-over) sur mobile : Description / Details / Documents.
   Custom element <onglets-produit>. */
if (!customElements.get('onglets-produit')) {
  class OngletsProduit extends HTMLElement {
    constructor() {
      super();
      this.openPanel = null;
      this.lastFocus = null;
    }

    connectedCallback() {
      this.setupReadmore();
      this.bindEvents();
      this._onResize = this.debounce(() => this.setupReadmore(), 200);
      window.addEventListener('resize', this._onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
      if (this._onKeydown) document.removeEventListener('keydown', this._onKeydown);
      this.unlockScroll();
    }

    debounce(fn, wait) {
      let t;
      return () => {
        clearTimeout(t);
        t = setTimeout(fn, wait);
      };
    }

    /* -------- Read-more -------- */
    setupReadmore() {
      this.querySelectorAll('[data-op-readmore]').forEach((wrap) => {
        const text = wrap.querySelector('.onglets-produit__readmore-text');
        const toggle = wrap.querySelector('[data-op-readmore-toggle]');
        if (!text || !toggle) return;
        if (wrap.classList.contains('is-expanded')) return;
        // Mesure le debordement uniquement quand l'element a une hauteur (visible / hors-flux mais avec layout).
        if (text.clientHeight === 0) return;
        const overflowing = text.scrollHeight - text.clientHeight > 2;
        toggle.hidden = !overflowing;
        if (overflowing && !toggle.dataset.bound) {
          toggle.dataset.bound = '1';
          toggle.addEventListener('click', () => {
            const expanded = wrap.classList.toggle('is-expanded');
            toggle.textContent = expanded ? 'Voir moins' : 'En savoir plus';
          });
        }
      });
    }

    /* -------- Slide-over mobile -------- */
    bindEvents() {
      this.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-op-target]');
        if (trigger && this.contains(trigger)) {
          e.preventDefault();
          this.open(trigger.getAttribute('data-op-target'), trigger);
          return;
        }
        const closer = e.target.closest('[data-op-close]');
        if (closer && this.contains(closer)) {
          e.preventDefault();
          this.close();
        }
      });
      this._onKeydown = (e) => {
        if (e.key === 'Escape' && this.openPanel) this.close();
      };
      document.addEventListener('keydown', this._onKeydown);
    }

    open(id, trigger) {
      let panel = null;
      try {
        panel = this.querySelector('#' + CSS.escape(id));
      } catch (err) {
        panel = document.getElementById(id);
      }
      if (!panel) return;
      this.lastFocus = trigger || document.activeElement;
      this.openPanel = panel;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      this.lockScroll();
      this.setupReadmore();
      const closeBtn = panel.querySelector('.onglets-produit__m-close, [data-op-close]');
      if (closeBtn) closeBtn.focus();
    }

    close() {
      if (!this.openPanel) return;
      const panel = this.openPanel;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      this.unlockScroll();
      this.openPanel = null;
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
    }

    lockScroll() {
      document.documentElement.classList.add('onglets-produit-noscroll');
    }

    unlockScroll() {
      document.documentElement.classList.remove('onglets-produit-noscroll');
    }
  }

  customElements.define('onglets-produit', OngletsProduit);
}
